export default {
  getPageName: $router => {
    let pageName = $router.currentRoute.path.split('/').filter(p => ['', 'pages', 'admin', 'view', 'edit', 'create'].indexOf(p) === -1).join('_');
    if (!pageName) {
      pageName = 'main';
    }
    return pageName;
  },
  getRoleRoute: (adminRoute, type) => {
    if (type === 'admin') {
      return adminRoute;
    }
    return adminRoute.replace('admin', type);
  }
};
